import { MembersList } from '../components/MembersList';
import { useAuth } from '../hooks/useAuth';

export const MembersPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <section id="members" className="page-section">
      <div className="page-header">
        <div>
          <p className="page-eyebrow">Directory</p>
          <h2 className="page-title">Members</h2>
          <p className="page-copy">Member directory and roster management.</p>
        </div>
      </div>
      {user?.role === 'scanner' ? (
        <div className="list-container">
          <h3>Recent Members</h3>
          <p className="empty-state">Members are hidden for scanner role.</p>
        </div>
      ) : (
        <MembersList />
      )}
    </section>
  );
};
